import React, { useEffect } from "react";
import { Toast, Button, ButtonToolbar } from "react-bootstrap";
import { _t } from "../../../app/i18n/i18n";
import { FaIcon } from "../../../lib/FaIcon";

const NOTIFICATION_TIMEOUT = 5000;
export const DownloadFailureToast = ({ setShowErrorToast, showErrorToast }) => {
  const onClose = () => {
    setShowErrorToast(false);
  };
  useEffect(() => {
    setTimeout(onClose, NOTIFICATION_TIMEOUT);
  });
  return (
    <Toast
      onClose={onClose}
      show={showErrorToast}
      className="d-flex mb-2 flex-basis-auto"
      style={{ position: "fixed", right: 0, bottom: "30px", zIndex: 100 }}
    >
      <ToastIcon icon="fas fa-exclamation" bg="bg-warning" />
      <article className="w-100">
        <Toast.Header className="text-dark font-weight-bold">
          {_t("Unable to download calendar invite")}
          <span className="mr-auto" />
        </Toast.Header>

        <Toast.Body>
          {_t("Sorry, there was an error serving this request, please try again later")}
          <ButtonToolbar className="justify-content-between flex-row-reverse mt-3">
            <DismissButton onClose={onClose} />
          </ButtonToolbar>
        </Toast.Body>
      </article>
    </Toast>
  );
};
const DismissButton = ({ onClose }) => (
  <Button onClick={onClose} variant="outline-secondary btn-sm ml-2">
    {_t("Dismiss")}
  </Button>
);

const ToastIcon = ({ bg, icon }) => (
  <aside className={"d-flex flex-column " + bg}>
    <FaIcon icon={icon + " text-white fa-3x m-auto"} />
  </aside>
);
